import React from 'react';
import { Route } from 'react-router-dom';
import Subscription from '../../Payment-Users/Dashboard-subscription.js';
import Paymentdetails1 from '../../Payment-Users/Paymentdetails1.js';
import Paymentdetails2 from '../../Payment-Users/Paymentdetails2.js';
import PaymentStatistics from '../../Payment-Users/PaymentStatistics.js';
import RefundActivity from '../../Payment-Users/RefundActivity.js';
import AdminTimePoolPage from '../../Payment-Users/AdminTimePoolPage.js';
import AddonPlansPage from '../../Payment-Users/AddonPlansPage.js';
import { guardRoute } from '../ProtectedRoute';

export const paymentRoutes = [
  <Route
    key="subscription"
    path="/subscription-analysis"
    element={guardRoute(<Subscription />, '/subscription-analysis')}
  />,
  <Route key="payments" path="/Payments" element={guardRoute(<Paymentdetails1 />, '/Payments')} />,
  <Route
    key="user-payments"
    path="/user-payments/:email"
    element={guardRoute(<Paymentdetails2 />, '/user-payments/')}
  />,
  <Route
    key="payment-statistics"
    path="/payment-statistics"
    element={guardRoute(<PaymentStatistics />, '/payment-statistics')}
  />,
  <Route
    key="refund-activity"
    path="/refund-activity"
    element={guardRoute(<RefundActivity />, '/refund-activity')}
  />,
  <Route
    key="admin-time-pools"
    path="/admin-time-pools"
    element={guardRoute(<AdminTimePoolPage />, '/admin-time-pools')}
  />,
  <Route
    key="addon-plans"
    path="/addon-plans"
    element={guardRoute(<AddonPlansPage />, '/addon-plans')}
  />,
];
